// @version V0.0.5 [Tuesday - 20210112_105621] : sort mutation and add some mutation
// @version V0.0.4 [Thursday - 20201210_165118] : add SET_QUICK_LIST , some revision SALE -> TRANSACTION 
// @version V0.0.3 [Monday - 20201130_215614] : added info tips for SET_FORM, UPDATE_IN_LIST, add CART, DETAIL
// @version V0.0.2 [Saturday - 20201114_203539] : new const, and sorting constant 
// @version V0.0.1 [Tuesday - 20201103_092924] : init

//-> CART
export const ADD_TO_CART = 'ADD_TO_CART'
export const CLEAN_CART = 'CLEAN_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const SELECT_CART = 'SELECT_CART'
export const SELECT_ALL_CART = 'SELECT_ALL_CART'
export const UNSELECT_ALL_CART = 'UNSELECT_ALL_CART'

//-> DETAIL
export const SET_DETAIL = 'SET_DETAIL'
export const RESET_DETAIL = 'RESET_DETAIL'
export const REFRESH_DETAIL = 'REFRESH_DETAIL'

//-> FILES
export const SET_FILES = 'SET_FILES'
export const REMOVE_FILE_IN_FILES = 'REMOVE_FILE_IN_FILES'

//-> FORM
export const RESET_FORM = 'RESET_FORM'
export const SET_FORM = 'SET_FORM' // should use Object.assign, to prevent list being changed too
export const SET_FORMS = 'SET_FORMS' // insert many row
export const UPDATE_FORM = 'UPDATE_FORM'

//-> LOADING
export const SET_LOADING = 'SET_LOADING'

//-> LIST
export const ADD_IN_LIST = 'ADD_IN_LIST'
export const REMOVE_IN_LIST = 'REMOVE_IN_LIST'
export const UPDATE_IN_LIST = 'UPDATE_IN_LIST' // sometimes only works with Object.assign
export const SET_LIST = 'SET_LIST'
export const RESET_LIST = 'RESET_LIST'
export const SET_KEY_LIST = 'SET_KEY_LIST'
export const SET_QUICK_LIST = 'SET_QUICK_LIST' //show without paginate, usually only take top 50

//-> OPTION
export const SET_OPTION = 'SET_OPTION'
export const ADD_TO_OPTION = 'ADD_TO_OPTION'
export const REMOVE_FROM_OPTION = 'REMOVE_FROM_OPTION'
export const UPDATE_IN_OPTION = 'UPDATE_IN_OPTION'

//-> REQUEST
export const REQUEST_SENDING = 'REQUEST_SENDING'
export const REQUEST_SENDED = 'REQUEST_SENDED'
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'
export const REQUEST_FAILED = 'REQUEST_FAILED'

//-> ROW
export const ADD_ROW = 'ADD_ROW'
export const REMOVE_ROW = 'REMOVE_ROW'
export const CALCULATE_ROW = 'CALCULATE_ROW'

//-> RESET STATE
export const RESET_STATE = 'RESET_STATE'

//-> SEARCH PARAMS
export const RESET_SEARCH_PARAMS = 'RESET_SEARCH_PARAMS'
export const UPDATE_SEARCH_PARAMS = 'UPDATE_SEARCH_PARAMS'

// customizing
export const ADD_PRODUCT_ITEMS_ROW = 'ADD_PRODUCT_ITEMS_ROW'
export const REMOVE_PRODUCT_ITEMS_ROW = 'REMOVE_PRODUCT_ITEMS_ROW'
export const FORM_RESET_PARENT_ACCOUNT = 'FORM_RESET_PARENT_ACCOUNT'
export const FORM_ACCOUNT_SELECTED = 'FORM_ACCOUNT_SELECTED'
export const ADD_ADDRESSES_ROW = 'ADD_ADDRESSES_ROW'
export const REMOVE_ADDRESSES_ROW = 'REMOVE_ADDRESSES_ROW'
export const ADD_CONTACTS_ROW = 'ADD_CONTACTS_ROW'
export const REMOVE_CONTACTS_ROW = 'REMOVE_CONTACTS_ROW'

export const UPDATE_DETAIL_PAYMENT = 'UPDATE_DETAIL_PAYMENT'
export const ADD_PAYMENT_TO_DETAIL = 'ADD_PAYMENT_TO_DETAIL'

export const SET_DUE_DATE_LIST = 'SET_DUE_DATE_LIST'
export const RESET_DUE_DATE_LIST = 'RESET_DUE_DATE_LIST'
export const SELECT_DUE_DATE_FILTER = 'SELECT_DUE_DATE_FILTER'

export const SET_FORM_PAYMENT = 'SET_FORM_PAYMENT'
export const RESET_FORM_PAYMENT = 'RESET_FORM_PAYMENT'

export const SET_FORM_PAYMENT_SCHEDULE = 'SET_FORM_PAYMENT_SCHEDULE'
export const RESET_FORM_PAYMENT_SCHEDULE = 'RESET_FORM_PAYMENT_SCHEDULE'
export const ADD_TRANSACTION_PAYMENT_ROW = 'ADD_TRANSACTION_PAYMENT_ROW'
export const REMOVE_TRANSACTION_PAYMENT_ROW = 'REMOVE_TRANSACTION_PAYMENT_ROW'
export const CALCULATE_TRANSACTION_PAYMENT_ROW = 'CALCULATE_TRANSACTION_PAYMENT_ROW'

export const FORM_PAYMENT_UPDATE_CALCULATION = 'FORM_PAYMENT_UPDATE_CALCULATION'
export const FORM_UPDATE_CALCULATION = 'FORM_UPDATE_CALCULATION'
export const FORM_CALCULATE_BALANCE = 'FORM_CALCULATE_BALANCE'
export const FORM_CHECK_SAME_TRANSFER = 'FORM_CHECK_SAME_TRANSFER'
export const FORM_UPDATE_COMPANY = 'FORM_UPDATE_COMPANY'
export const FORM_ADD_ITEM_TO_TRANSACTION = 'FORM_ADD_ITEM_TO_TRANSACTION'
export const FORM_ADD_ITEM_QTY_TO_TRANSACTION = 'FORM_ADD_ITEM_QTY_TO_TRANSACTION'
export const FORM_CALCULATE_TRANSACTION = 'FORM_CALCULATE_TRANSACTION'
export const FORM_CALCULATE_ITEM = 'FORM_CALCULATE_ITEM'
export const FORM_SET_DEFAULT = 'FORM_SET_DEFAULT'
export const FORM_SET_COMPANY_TRANSACTION = 'FORM_SET_COMPANY_TRANSACTION'
export const FORM_REMOVE_ITEM_FROM_TRANSACTION = 'FORM_REMOVE_ITEM_FROM_TRANSACTION'
export const FORM_REMOVE_ALL_ITEM_FROM_TRANSACTION = 'FORM_REMOVE_ALL_ITEM_FROM_TRANSACTION'

export const SET_PROOFS = 'SET_PROOFS'
export const REMOVE_PROOF_IN_PROOFS = 'REMOVE_PROOF_IN_PROOFS'